export enum SportType {
    ADVENTURE_RACING = 1,
    AQUATHLON = 2,
    BACKYARD_ULTRA = 3,
    BASKETBALL = 4,
    BEER_MILE = 5,
    CANICROSS = 6,
    CROSS_COUNTRY_SKIING = 7,
    CROSS_RUNNING = 8,
    CROSSFIT = 9,
    CYCLING_CYCLOCROSS = 10,
    CYCLING_ENDURO = 11,
    CYCLING_GRAVEL = 12,
    CYCLING_MOUNTAINBIKE = 13,
    CYCLING_PUMPTRACK = 14,
    CYCLING_ROAD = 15,
    DUATHLON = 16,
    ENDURO_AUTO_RACING = 17,
    ENDURO_CROSS_COUNTRY = 18,
    FITNESS = 19,
    FOOTBALL = 20,
    HANDBALL = 21,
    HIKING = 22,
    KAYAK = 23,
    MOTOCROSS = 24,
    MULTISPORT = 25,
    NORDIC_WALKING = 26,
    ORIENTEERING = 27,
    OTHER = 28,
    PADDLING = 29,
    ROAD_RUNNING = 30,
    ROLLER_SKATING = 31,
    ROWING = 32,
    SKIING = 33,
    SUP = 34,
    SWIMMING = 35,
    TRAIL_RUNNING = 36,
    TRIATHLON = 37,
    VELODROME = 38,
    VOLLEYBALL = 39,
    WALKING = 40,
    WATER_POLO = 41,
    HYBRID_RACE = 48,
}
